import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=7feada01&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=7feada01&prod&lang=scss&scoped=true&"
import style1 from "./Attachment.vue?vue&type=style&index=1&id=7feada01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feada01",
  null
  
)

export default component.exports